import React from 'react';
import '../styles/ProgressBar.css';
export default function ColorfulProgressBar({ percentage = 78 }) {
	return (
		<div className='background-color h-[3px] flex-1 flex flex-row justify-end rounded-[7px] overflow-hidden'>
			<div className={`h-full bg-[#ECEBF8]`} style={{ width: `${100 - percentage}%` }}></div>
		</div>
	);
}
